<script setup lang="ts">
  import { ref, onMounted } from 'vue'

  const visible = ref(true)

  const props = defineProps<{
    message: string
    type?: 'success' | 'error' | 'info'
    duration?: number
    onClose?: () => void
  }>()

  onMounted(() => {
    if (props.duration !== 0) {
      setTimeout(() => {
        visible.value = false
        props.onClose?.()
      }, props.duration || 2000)
    }
  })
</script>

<template>
  <div class="message-container">
    <transition name="message-fade">
      <div v-show="visible" class="message" :class="type">{{ message }}</div>
    </transition>
  </div>
</template>

<style lang="stylus" scoped>
  .message-container
    width 500px
    top 16%
    left 50%
    transform translateX(-50%)
    height: 100px
    position fixed
    // border 1px solid red
    z-index 9999
  .message
    position absolute // 改为相对定位
    left 50%
    top 241px // 在登录框上方显示
    transform translateX(-50%)
    padding 8px 16px
    border-radius 8px
    background rgba(16, 16, 16, 0.8)
    color #fff
    font-size 14px
    z-index 9999
    text-align center
    max-width 90%
    line-height 150%
    white-space pre-wrap

    &.success
      background rgba(0, 0, 0, 0.8)

    &.error
      background rgba(0, 0, 0, 0.8)

    &.info
      background rgba(0, 0, 0, 0.8)

  .message-fade-enter-active,
  .message-fade-leave-active
    transition all 0.3s ease

  .message-fade-enter-from,
  .message-fade-leave-to
    opacity 0
    transform translateX(-50%) translateY(-20px)
</style>
